import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CardDisplayStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  LOCKED: 'locked',
  BLOCKED: 'blocked',
  CANCELED: 'canceled',
  UNKNOWN: 'unknown',
} as const

export type CardDisplayStatusEnum = Enum<typeof CardDisplayStatuses>
